import React from 'react';

function CheckmarkSVG(props) {
  return (
    <svg width={16} height={12} viewBox='0 0 16 12' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M.002 6.236L2.97 3.169l2.673 3L12.85 0l2.153 2.259L5.578 12 .002 6.236z'
        fill='#5EBAA9'
      />
    </svg>
  );
}

export default CheckmarkSVG;
